/**
 * Per-tour list of which space-variant tabs (Actual / Empty / Reno A …)
 * the Photography section shows to viewers. Picked in Developer Mode;
 * an absent file means no tabs are shown.
 *
 * Storage: gs://{bucket}/tours/{tourId}/space-variants.json
 *   { visible: string[], updatedAt }
 *
 * Read and written directly with the Storage SDK (same client-side path
 * the floorplan-variant uploads use), so no Cloud Function is involved.
 */

import {
  getBytes,
  getStorage,
  ref as storageRef,
  uploadString,
} from 'firebase/storage';

function objectPath(tourId: string): string {
  const id = tourId.startsWith('tours/') ? tourId.slice(6) : tourId;
  return `tours/${id}/space-variants.json`;
}

export async function getTourVisibleSpaceVariants(
  tourId: string,
): Promise<string[]> {
  try {
    const bytes = await getBytes(storageRef(getStorage(), objectPath(tourId)));
    const data = JSON.parse(new TextDecoder().decode(bytes));
    return Array.isArray(data?.visible)
      ? data.visible.filter((v: unknown) => typeof v === 'string')
      : [];
  } catch (err) {
    if ((err as { code?: string })?.code === 'storage/object-not-found') {
      return [];
    }
    throw err;
  }
}

export async function setTourVisibleSpaceVariants(
  tourId: string,
  visible: string[],
): Promise<void> {
  await uploadString(
    storageRef(getStorage(), objectPath(tourId)),
    JSON.stringify({ visible, updatedAt: new Date().toISOString() }),
    'raw',
    { contentType: 'application/json', cacheControl: 'no-cache' },
  );
}
